module.exports = __webpack_public_path__ + "img/nicard-logo-part-1.be98a343.png";